import { mapGetters } from 'vuex'
import cssVars from 'css-vars-ponyfill'

import globalConfig from '@/config/index'
export default {
    computed: {
        ...mapGetters('design', [
            'cssAllVar'

            // ...
        ])
    },
    watch: {
        cssAllVar: {
            handler(obj) {
                if (!this.$store.state.api.loading) return

                if (obj) {
                    let variablesRename = {}
                    for (let prop in obj) {
                        variablesRename['--effect-widget-' + prop] = obj[prop]
                    }

                    let vars = {
                        onlyLegacy: true,
                        variables: variablesRename,
                        watch: true,
                        //preserveVars: true,
                        onWarning(message) {},
                        onError(message, elm, xhr, url) {},
                        onSuccess(cssText, elm, url) {
                            return cssText
                        },
                        onComplete: (cssText, styleElms, cssVariables, benchmark) => {
                            setTimeout(() => {
                                this.$store.commit('setLoader', false)
                            }, 500)
                        }
                    }

                    cssVars(vars)

                    setTimeout(() => {
                        this.$root.$emit('setButtonSize')
                    }, 500)
                }
            },
            immediate: true
        }
    },
    mounted() {
        window.effectWidgetSetOptions = this.setOptions
        window.dx_widget = this.dx_widget
    },
    beforeDestroy() {},
    methods: {
        dx_widget(param) {
            //Раскрытие виджета по клику на стороннюю кнопку/ссылку
            if (param === 'click') {
                window.effectWidgetSetOptions({ showChat: true })
            }
        },

        setOptions({
            position: { left, top, zIndex } = {},
            showWidget,
            showBtnStart,
            showChat,
            init
        }) {
            // console.log('effectWidgetSetOptions', {
            //     showWidget,
            //     showBtnStart,
            //     showChat,
            //     init,
            //     left,
            //     top,
            //     zIndex
            // })
            this.$store.commit('design/setLocalStorage', {
                zIndex,
                left,
                top,
                showWidget,
                showBtnStart
            })
            if (showChat !== undefined) {
                if (!init && !this.$store.state.chatActive && showChat) {
                    this.$root.$emit('setChatActive', showChat)
                    this.$root.$emit('initPoint')
                } else {
                    this.$root.$emit('setChatActive', showChat)
                }
            }
            if (init) {
                this.$root.$emit('setInitStarted')
                this.$root.$emit('initPoint')
            }
        }
    }
}
